import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  getOrderPathType,
  trimText,
} from '../../../../utility/util/util.service';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import {
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
  setIsSelectBillingAddressModalOpen,
  setSelectBillingAddressModalData,
  setIsCreateBillingAddressModalOpen,
  setCreateBillingAddressModalData,
} from '../../../../redux/modal/modal.actions';
import {
  fetchBillingAddresses,
  fetchOrders,
} from '../../../../redux/me/me.actions';
import { notification } from '../../../../utility/notification/notification.service';
import { basePatchQuery } from '../../../../utility/sb-api/sb-api.service';
import { fetchStoreOrders } from '../../../../redux/store/store.actions';

import * as Icon from 'react-feather';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import { useRef } from 'react';

const SelectBillingAddressModal = ({
  isOpen,
  data, // {order: Order, isAdminMode: boolean} !!!
  userOrders,
  storeOrders,
  me,
  store,
  billingAddresses,
  openedOrderInfoModal,

  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
  fetchStoreOrders,
  setIsSelectBillingAddressModalOpen,
  setSelectBillingAddressModalData,
  setIsCreateBillingAddressModalOpen,
  fetchOrders,
  fetchBillingAddresses,
  setCreateBillingAddressModalData,
}) => {
  const intl = useIntl();
  const [order, setOrder] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isAdminMode = !!(data && data.isAdminMode);
  const [selectedBillingAddressId, setSelectedBillingAddressId] = useState(
    null,
  );
  // find the order by given order.id
  useEffect(() => {
    if (isOpen) {
      // decide from which array to select the given order
      const targetOrders = isAdminMode ? storeOrders : userOrders;

      if (targetOrders && data?.order) {
        const foundOrder = targetOrders?.find(
          ({ id }) => id === data.order?.id,
        );
        setOrder(foundOrder || null);
      } else {
        notification('error', 'defaultUnknownError');
      }
    } else {
      setOrder(null); // cleanup after close
    }
  }, [storeOrders, userOrders, data, isOpen]);

  const handleSendInvoice = () => {
    setIsSubmitting(true);
    const orderType = getOrderPathType(order.type);
    basePatchQuery(`orders/${orderType}/${order.id}`, {
      billingAddressId: selectedBillingAddressId,
    })
      .then(() => {
        notification('success', 'invoiceMessageSuccess');
        setOrder(null);
        fetchBillingAddresses(true, setIsOrderInfoModalOpen, setIsSubmitting);
        setIsSubmitting(false);
      })
      .catch(() => {
        setIsSubmitting(false);
        notification('error', 'changesSavedError');
        setOrder(null);
      });
  };

  const closeModal = () => setIsSelectBillingAddressModalOpen(false);

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={closeModal}
      title={intl.formatMessage({ id: 'billingAddressesTitle' })}
      footer={
        <div className="align-content-center">
          {!isAdminMode && (
            <div className="align-content-center d-flex m-auto">
              <SaveSubmitButton
                isSubmitting={isSubmitting}
                messageId="sendInvoiceLabel"
                onClick={handleSendInvoice}
                disabled={isSubmitting || !selectedBillingAddressId}
              />
            </div>
          )}
        </div>
      }
    >
      <>
        <div className="px-1">
          <span className="font-small-3 mb-2">
            <FormattedMessage id="selectBillingAddressLabel" />
          </span>
          {billingAddresses?.map((billingAddress, index) => {
            const descriptor = [
              billingAddress.companyName ||
                [billingAddress.firstName, billingAddress.lastName].join(' '),
              billingAddress.line1,
              billingAddress.line2,
              [billingAddress.zip, billingAddress.city].join(' '),
            ]
              .filter((part) => !!part)
              .join(', ');
            return (
              <div
                key={index}
                style={{ transition: 'border 300ms', height: '50px' }}
                className={classnames(
                  'd-flex justify-content-between align-items-center my-50 p-75 border rounded',
                  {
                    'border-primary':
                      selectedBillingAddressId === billingAddress.id,
                  },
                )}
                onClick={() =>
                  selectedBillingAddressId !== billingAddress?.id &&
                  setSelectedBillingAddressId(billingAddress.id)
                }
              >
                <div>
                  {billingAddress?.id === selectedBillingAddressId ? (
                    <Icon.CheckSquare
                      className="vx-icon mr-1 primary"
                      size={24}
                    />
                  ) : (
                    <Icon.Square className="vx-icon mr-1" size={24} />
                  )}
                  <span>{trimText(descriptor, 40)}</span>
                </div>
              </div>
            );
          })}

          <div
            style={{
              transition: 'border 300ms',
              height: '50px',
            }}
            className={classnames(
              'd-flex justify-content-between align-items-center my-50 p-75 border dashed rounded',
            )}
            onClick={() => {
              setSelectedBillingAddressId(null);
              setIsCreateBillingAddressModalOpen(true);
              setCreateBillingAddressModalData({ openedFromOrderInfo: true });
            }}
          >
            <div className="d-flex align-items-center">
              <Icon.Plus size={20} className="mr-50" />
              <span>
                <FormattedMessage id="createNewBillingAddressTitle" />
              </span>
            </div>
          </div>
        </div>
      </>
    </ModalSheet>
  );
};

SelectBillingAddressModal.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object,
  setIsOrderInfoModalOpen: PropTypes.func,
  setOrderInfoModalData: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isSelectBillingAddressModalOpen,
  data: state.modals.orderInfoModalData,
  userOrders: state.me.orders,
  store: state.store.store,
  me: state.me.me,
  storeOrders: state.store.storeOrders,
  billingAddresses: state.me.billingAddresses,
  openedOrderInfoModal:
    state.modals.createBillingAddressModalData?.openedFromOrderInfo,
});

export default connect(mapStateToProps, {
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
  fetchStoreOrders,
  setIsSelectBillingAddressModalOpen,
  setSelectBillingAddressModalData,
  setIsCreateBillingAddressModalOpen,
  fetchOrders,
  fetchBillingAddresses,
  setCreateBillingAddressModalData,
})(SelectBillingAddressModal);
